import React from 'react'

import Experiment from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'

import { GiftButton } from '../../components'
import { LOCATION } from '../../lib/events'
import { useGiftEnabled } from '../../lib/helpers'
import { GLOBAL_CTAS_PROMO_BANNER_FLAG_NAME } from './constants'

interface GlobalCtaExperimentProps {
  children: React.ReactNode
  ctaHref: string
}

export const GlobalCtaBannerExperiment = ({
  children,
  ctaHref,
}: GlobalCtaExperimentProps) => {
  const { giftEnabled } = useGiftEnabled()
  const { isPromotionOn } = usePromotion()

  if (!giftEnabled || !isPromotionOn) return children

  return (
    <Experiment
      name={GLOBAL_CTAS_PROMO_BANNER_FLAG_NAME}
      control={() => children}
      variant_1={() => (
        <div className='d-flex flex-gap-2 align-items-end'>
          {/* Tablet & Desktop */}
          <div className='d-none d-md-block'>
            <GiftButton size='sm' location={LOCATION} href={ctaHref} />
          </div>

          {/* Mobile */}
          <div className='d-block d-md-none'>
            <GiftButton
              size='sm'
              className='mc-py-2 mc-px-8'
              location={LOCATION}
            />
          </div>
          {children}
        </div>
      )}
    />
  )
}
